<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
        <div class="card crd p-3">
            <div class="row">
                <div class="col-md-10 col10 mt-2">
                    <h2>G-Store </h2>
                </div>
                <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
                    alt=""> </button> </a>
                </div>
                <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='41'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
                <div class="col-md-12 mt-2" (mouseover)="showpayment(true,'2')" (mouseout)="showpayment(false,'2')"
                    id="42">

                    <label for="" class="mt-2">A G-store, also known as an
                        e-commerce store or
                        online
                        shop,
                        is a
                        digital platform where businesses or merchants sell products or services
                        over
                        the
                        Internet. It allows customers to browse, select, and purchase items or
                        services
                        using a
                        PayG mobile app, rather than visiting a physical brick-and-mortar store.
                        We're
                        excited
                        to share an exceptional opportunity that's designed to elevate your business
                        and
                        boost
                        your online presence. By creating your profile on our PayG mobile app, you
                        unlock a
                        world of exclusive benefits and features tailored to enhance your online
                        shopping
                        store
                        experience. We have a product library with over 1.5 crore offerings.
                    </label>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')" (mouseout)="showpayment(false,'3')"
                    id="43">
                    <h2>Here are some features of our G-store listed below: </h2>

                    <label for="" class="mt-3"><b>Business Card:</b>&nbsp; Think of
                        your business
                        card
                        as
                        your
                        digital identity. Once you create your profile, you'll have a customizable
                        business
                        card
                        that showcases your brand, logo, and essential business details. It's a
                        powerful
                        way
                        to
                        make a lasting impression and let customers know who you are. </label>

                    <label for="" class="mt-3"><b>Stamps:</b>&nbsp; Verified
                        products deserve
                        recognition,
                        and
                        that's where our stamps come in. With these stamps, you can mark your
                        products
                        as
                        verified and trustworthy. It's a signal to your customers that they're
                        getting
                        quality
                        items from a reliable source.</label>

                    <label for="" class="mt-3"><b>Coupons:</b>&nbsp; Who doesn't
                        love a good deal?
                        With
                        our
                        coupon feature, you have the ability to offer discounts to your customers.
                        This
                        not
                        only
                        encourages more purchases but also builds customer loyalty. Create enticing
                        offers
                        and
                        watch your sales grow. </label>

                    <label for="" class="mt-3"><b>Profile QR Code:</b>&nbsp;Simplify
                        the shopping
                        experience
                        for
                        your customers. Each merchant profile comes with a unique QR code. When
                        customers
                        scan
                        this code, they're taken directly to your profile, where they can explore
                        your
                        products
                        and make purchases effortlessly. It's like having your store at their
                        fingertips.

                    </label>

                    <label for="" class="mt-3"><b>Payment QR Code:</b>&nbsp; Making
                        payments
                        smoother
                        than
                        ever.
                        Generate a payment QR code that your customers can scan to complete their
                        transactions
                        securely and swiftly. This feature streamlines the checkout process,
                        ensuring a
                        seamless
                        buying experience. </label>

                    <label for="" class="mt-3"><b>24/7 Customer Support:</b>&nbsp;
                        Have questions or
                        need
                        assistance? Our dedicated customer support team is available around the
                        clock to
                        provide
                        timely solutions and ensure a smooth shopping experience. </label>

                    <label for="" class="mt-3"> The "Item" section offers three
                        options for adding
                        items
                        to
                        a
                        cart: "Add products from the G-store library," "Scan any product and add to
                        your
                        cart,"
                        and "Add the items manually." The merchants are allowed to choose whichever
                        method
                        they
                        choose. The merchants can also generate their own Profile QR and Store QR
                        codes.
                        Also
                        features like business cards and stamps are available on the G-store.

                    </label>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')" (mouseout)="showpayment(false,'4')"
                    id="44">
                    <h2>
                        Benefits of using PayG's G-Store
                    </h2>
                    <h5 class="mt-3">Convenience for Customers </h5>
                    <label for="" class="mt-1">G-store provides your customers with
                        the convenience
                        of
                        shopping
                        from anywhere at any time, eliminating the need to visit your physical
                        store.
                        This
                        accessibility is especially advantageous for individuals with busy
                        schedules.
                    </label>

                    <h5 class="mt-3">Time flexibility </h5>
                    <label for="" class="mt-1">You have the flexibility to set the
                        operating hours
                        of
                        your
                        G-Store according to your preferred schedule. This means you can customize
                        the
                        time
                        during which your online store is accessible to customers. Whether you want
                        to
                        align
                        it
                        with specific time zones, cater to a particular target audience, or simply
                        match
                        your
                        own availability, the ability to set the time schedule provides you with a
                        convenient
                        way to manage and optimize the operational hours of your G-Store to meet
                        your
                        business
                        needs and customer expectations. </label>

                    <h5 class="mt-3">Cost-Effective </h5>
                    <label for="" class="mt-1">

                        Operating an online G-Store often involves lower overhead costs compared to
                        maintaining
                        a physical storefront. G-store can save on expenses related to rent,
                        utilities,
                        and
                        in-store staff. </label>

                    <h5 class="mt-3">Diverse Product Range </h5>
                    <label for="" class="mt-1">G-store provides the opportunity for
                        businesses to
                        showcase a
                        diverse range of products without the constraints of physical space. This
                        variety
                        attracts a wider range of customers with different preferences and needs.
                    </label>

                    <h5 class="mt-3">Ease of Search and Navigation </h5>
                    <label for="" class="mt-1">G-store platforms typically offer
                        search and filter
                        features,
                        making it easy for your customers to find specific products. This enhances
                        the
                        overall
                        shopping experience. </label>

                    <h5 class="mt-3">Customer Reviews and Ratings </h5>
                    <label for="" class="mt-1">G-store allows customers to leave
                        reviews and ratings
                        for
                        products, which can influence the purchasing decisions of other shoppers.
                        This
                        transparency helps build credibility for the online store. </label>

                    <h5 class="mt-3">Efficient Inventory Management </h5>
                    <label for="" class="mt-1">G-store can implement advanced
                        inventory management
                        systems,
                        ensuring that product availability is accurately reflected on the platform.
                        This
                        reduces
                        the likelihood of overselling or disappointing customers. </label>

                    <h5 class="mt-3">Data Analytics for Business Insights </h5>
                    <label for="" class="mt-1">G-store can utilize data analytics
                        tools to gather
                        insights
                        into
                        customer behavior, preferences, and purchasing patterns. This data can be
                        invaluable
                        for
                        making informed business decisions and optimizing the online shopping
                        experience.
                    </label>

                    <h5 class="mt-3">Marketing Opportunities </h5>
                    <label for="" class="mt-1">G-store can easily implement various
                        online marketing
                        strategies,
                        including social media campaigns, email marketing, and search engine
                        optimization,
                        to
                        attract and retain customers. </label>

                </div>
                <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')" (mouseout)="showpayment(false,'5')"
                    id="45">
                    <h2>How to Get Started: </h2>
                    <label for="" class="mt-1">
                        Getting access to these incredible features is simple:

                    </label>

                    <h5 class="mt-4">Step 1: Sign in on PayG app</h5>
                    <label for="">
                        Sign into your merchant account by entering your credentials. If you are a
                        new user, sign up for a new account and log in with your credentials. You
                        can download our PayG mobile app from your device's app store.
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/g-store1.png" width="50%" height="95%" alt="">
                        </div>

                    </div>

                    <h5 class="mt-4">Step 2: Create Your Profile </h5>
                    <label for="">
                        Sign up or log in to your account within the app. Fill in your business
                        details,
                        upload
                        your logo, and customize your profile. In the first step, fill in your
                        business details. In the second step, update your business type, and then
                        select a category in the third step. </label>
                    <div class="row">
                        <div class="col-md-12 mt-2">
                            <img src="./assets/g-store2.png" width="50%" height="95%" alt="">
                        </div>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/g-store3.png" width="50%" height="95%" alt="">
                        </div>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/g-store4.png" width="50%" height="95%" alt="">
                        </div>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/g-store5.png" width="50%" height="95%" alt="">
                        </div>
                        <div class="col-md-12 mt-2">
                            <img src="./assets/g-store6.png" width="50%" height="95%" alt="">
                        </div>

                    </div>

                    <h5 class="mt-4">Step 3: Add inventory</h5>
                    <label for="">You can seamlessly integrate inventory using our
                        G-store library,
                        comprising 1.5 crore products. Alternatively, you may choose to scan the
                        barcode of your items to add them to your store. The third option involves
                        manually adding your products. </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/g-store7.png" width="50%" height="95%" alt="">
                        </div>

                    </div>

                    <h5 class="mt-4">Step 4: Explore and activate </h5>
                    <label for="">

                        Once your profile is set up, navigate to the 'G-Store' section. There,
                        you'll find options to activate your business card, stamps, coupons, profile
                        QR code, and payment QR code.
                    </label>
                    <div class="row">
                        <div class="col-md-12 mt-4">
                            <img src="./assets/g-store8.png" width="50%" height="95%" alt="">
                        </div>

                    </div>
                    <h5 class="mt-4">Step 5: Start Enjoying Benefits </h5>
                    <label for="">

                        With everything activated, you're ready to reap the rewards. Your online
                        shopping store will become more engaging, customer-friendly, and dynamic
                        than ever before.
                    </label>
                    <label for="" class="col-md-12 mt-4">

                        In this digital age, standing out and offering convenience to your customers
                        is paramount. By creating your profile on PayG app, you're taking a
                        significant step towards achieving these goals.
                    </label>

                </div>
            </div>
        </div>
    </div>
    <div class="col-md-4  hide-tbl content2  ">
        <div class="card crd p-4">
            <div class="row">
                <div class="col-md-12">
                    <h5>
                        Table of Contents:
                    </h5>
                </div>
                <!-- <div class="col-md-12 mt-2">
           <a href="#41">  <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        Introduction to G-Store </span>
                </div>
            </div></a>
        </div> -->
                <div class="col-md-12 mt-2">
                    <a href="#42">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">
                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='2'}"
                                    (click)="color('2')">
                                    Introduction to G-Store </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-0">
                    <a href="#43">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='3'}"
                                    (click)="color('3')"> Features
                                    of G-store </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-0">
                    <a href="#44">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='4'}"
                                    (click)="color('4')">
                                    Benefits of G-store </span>

                            </div>
                        </div>
                    </a>
                </div>
                <div class="col-md-12 mt-0">
                    <a href="#45">
                        <div class="row">
                            <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro" alt="">
                                &nbsp;</div>
                            <div class="col-md-10">

                                <span style="cursor: pointer;" class="textHover" [ngClass]="{'text':colors=='5'}"
                                    (click)="color('5')">How to get
                                    started? </span>

                            </div>
                        </div>
                    </a>
                </div>




            </div>
        </div>
    </div>
    <div class="col-md-9 hide ft-9">
        <hr>
        <div class=" row crd">
            <div class="col-md-8">
                <a [routerLink]="['/create-link']">   <button class="btn btn-color" (click)="menues('Create Payment')" >
                    <img src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;Create Payment
                </button></a>
                
            </div>
            <div class="col-md-4   ">
                <a [routerLink]="['/pay-button']"> <button class="btn btn-color" (click)="menues('Pay Button')" >Pay
                    Button
                    &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
               
            </div>
        </div>
    </div>
</div>